import { DynamicFormV2Palette } from "@mui/material";

export type FormTabsComponentTokenType = {
  groupBackgroundColor: string;
  tabBackgroundColor: string;
  tabHoverBackgroundColor: string;
  tabSelectedBackgroundColor: string;
  tabSelectedBorderColor: string;
  tabTextColor: string;
  tabSelectedTextColor: string;
  tabIconColor: string;
};

export const assignTabsComponentTokens = (formsPalette: DynamicFormV2Palette["forms"], mode: "light" | "dark") => {
  const isLightMode = mode === "light";

  return {
    groupBackgroundColor: isLightMode ? formsPalette.surface.quiet : formsPalette.surface.supershy,
    tabBackgroundColor: isLightMode ? formsPalette.surface.quiet : formsPalette.surface.supershy,
    tabHoverBackgroundColor: isLightMode ? formsPalette.surface.hover.moderate : formsPalette.surface.hover.quiet,
    tabSelectedBackgroundColor: isLightMode ? formsPalette.surface.moderate : formsPalette.surface.hover.quiet,
    tabSelectedBorderColor: isLightMode ? formsPalette.border.brand : formsPalette.border.intense,
    tabTextColor: formsPalette.text.intense,
    tabSelectedTextColor: formsPalette.text.intense,
    tabIconColor: formsPalette.text.error,
  } as FormTabsComponentTokenType;
};
